import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export const PlacementAction = ({
  actionText,
  placementActionClassName,
}) => (actionText ?
  <button disabled className={classnames(placementActionClassName)}>
    {actionText}
  </button> : null
);

PlacementAction.propTypes = {
  actionText: PropTypes.string,
  placementActionClassName: PropTypes.string,
};

PlacementAction.defaultProps = {
  actionText: undefined,
  placementActionClassName: undefined,
};
